import React, { useState, useEffect } from "react";
import moment from "moment";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./BillOfSale/Main";
import Form from "./BillOfSale/Form";

import {
  getDataWithComp,
  getDocStatusColour,
  getAlert,
} from "../../../utils/SamuiUtils";

import { getReport } from "../../../utils/ReportUtils";

const BillOfSale = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [statusColours, setStatusColours] = useState([]);
  const [statusPaidColours, setStatusPaidColours] = useState([]);
  const [maxDocNo, setMaxDocNo] = useState();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialize = async () => {
    try {
      setMode("S");

      const startDefaultDate = moment().format("YYYY-MM-DD 00:00:00");
      const endDefaultDate = moment().format("YYYY-MM-DD 23:59:59");

      let whInLocal = localStorage.getItem("WHID");
      if (!whInLocal) {
        whInLocal = "3";
        localStorage.setItem("WHID", whInLocal);
      }

      await setWHName();
      await fetchRealtime(startDefaultDate, endDefaultDate);
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const setWHName = async () => {
    const WHID = localStorage.getItem("WHID");
    if (!WHID) {
      getAlert("FAILED", "ไม่พบข้อมูลคลังสินค้า");
      return;
    }

    const whereCondition = `AND WH_Id = ${Number(WHID)}`;
    const result = await getDataWithComp("Tb_Set_WH", whereCondition);
    if (result && result.length > 0) {
      localStorage.setItem("WHName", result[0].WH_Name);
    } else {
      getAlert("FAILED", "ไม่พบชื่อคลังสินค้า");
    }
  };

  const fetchRealtime = async (startDate, endDate,includeCancelled) => {
    try {
      const WHID = Number(localStorage.getItem("WHID"));
      if (!WHID) {
        getAlert("FAILED", "ไม่พบข้อมูลคลังสินค้า");
        setDataMasterList([]);
        return [];
      }

      // normalize วันที่ + ครอบทั้งวัน + สลับกรณีใส่สลับ
      let s = moment(startDate);
      let e = moment(endDate);
      if (!s.isValid() || !e.isValid()) {
        getAlert("FAILED", "รูปแบบวันที่ไม่ถูกต้อง");
        setDataMasterList([]);
        return [];
      }
      if (e.isBefore(s)) [s, e] = [e, s];

      const startStr = s.startOf("day").format("YYYY-MM-DD 00:00:00");
      const endStr = e.endOf("day").format("YYYY-MM-DD 23:59:59");

      // includeCancelled: string -> boolean ชัดเจน
      const IncludeCancelled =
        includeCancelled === true;
      const cancelledClause = IncludeCancelled
        ? "" // แสดงทุกสถานะ
        : "AND (Doc_Status IS NULL OR Doc_Status != 13)"; // ซ่อน 13

      // ระบุ columns ที่ใช้งานจริงเพื่อลดข้อมูลที่ดึงมา (แทน SELECT *)
      const columns = `Doc_ID, Doc_No, Doc_Date, Doc_SEQ, Doc_Status, 
        Doc_Status_Paid, Doc_Status_Paid_Type, Doc_Is_PickingList, 
        AR_Code, AR_Name, NetTotal, WH_Id, Comp_Id, Ref_DocID,
        DocStatus_Name, DocStatus_Colour,
        DocStatusPaid_Name, DocStatusPaid_Colour,
        DocStatusPaid_Type_Name, DocStatusPaidType_Colour,
        Created_By_Name, Created_Date`;

      // ให้ database ทำการ sort ตามที่ต้องการ แทนที่จะ sort ที่ frontend
      const orderBy = `ORDER BY Doc_Date DESC, Doc_SEQ DESC, Doc_ID ASC`;

      // ส่งเฉพาะเงื่อนไข WHERE + ORDER BY
      const where = `
      AND Doc_Date BETWEEN '${startStr}' AND '${endStr}'
      AND WH_Id = ${WHID}
      ${cancelledClause}
      ${orderBy}
    `;

      const [masterList, docStatusColour, docStatusPaidColour] =
        await Promise.all([
          getDataWithComp("API_0701_SO_H", where, null, columns),
          getDocStatusColour("SO", "Doc_Status"),
          getDocStatusColour("SO", "Doc_Status_Paid"),
        ]);

      if (Array.isArray(docStatusColour) && docStatusColour.length)
        setStatusColours(docStatusColour);
      if (Array.isArray(docStatusPaidColour) && docStatusPaidColour.length)
        setStatusPaidColours(docStatusPaidColour);

      if (Array.isArray(masterList) && masterList.length) {
        // ข้อมูลถูก sort มาจาก database แล้ว ไม่ต้อง sort ซ้ำที่ frontend
        setDataMasterList(masterList);
        return masterList;
      }

      setDataMasterList([]);
      // if (typeof setPage === "function") setPage(1);
      return [];
    } catch (error) {
      getAlert("FAILED", error?.message || String(error));
      setDataMasterList([]);
      return [];
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (docNo) => {
    setMaxDocNo(docNo);
    localStorage.setItem("SO_SelectedItem", docNo);
    setMode("U");
  };

  return (
    <div className="PurchaseRequest">
      <button
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        className="btn btn-toggle-sidebar"
        style={{
          position: "fixed",
          top: "1rem",
          left: isSidebarOpen ? "190px" : "-15px",
          zIndex: 1001,
          background: "transparent",
          border: "none",
          color: "#EF6C00",
          fontSize: "20px",
        }}
      >
        {isSidebarOpen ? "✖" : "☰"}
      </button>

      <div className="wrapper">
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />

        <div
          className={`main-panel ${
            isSidebarOpen ? "sidebar-open" : "sidebar-closed"
          }`}
        >
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  statusColours={statusColours}
                  statusPaidColours={statusPaidColours}
                  name={"ใบขาย"}
                  onPageInsert={onPageInsert}
                  onRowSelected={onRowSelected}
                  getReport={getReport}
                  // ส่งฟังก์ชันตรง ๆ ลดการ re-create ทุก render
                  fetchRealtime={fetchRealtime}
                  WHID={localStorage.getItem("WHID")}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ใบขาย"}
                  maxDocNo={mode === "I" ? "" : maxDocNo}
                  onRowSelected={onRowSelected}
                  getReport={getReport}
                  isSidebarOpen={isSidebarOpen}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillOfSale;
